module.exports = {
    controller: htsGeneralNotesPageController,
    templateUrl: 'us/components/hts-general-notes-page.html',
};

htsGeneralNotesPageController.$inject = [
    '$analytics',
    '$location',
    'notificationsService'
];

function htsGeneralNotesPageController(
    $analytics,
    $location,
    notifications
) {
    var vm = {
        $onInit: attached,
        $onDestroy: detached,
    };
    return vm;

    function attached() {
        $analytics.pageTrack('/hts-general-notes');
        notifications.subscribe('filter_movement_changed', movementChanged)
    }

    function detached() {
        notifications.unsubscribe('filter_movement_changed', movementChanged);
    }

    function movementChanged(movement) {
        if (movement === 'export') {
            $location.path('/schedule-b-general-notes');
        }
    }
}